import * as React from 'react';
import API from '../../initialize/API.js';
import {AutoTrackTriage} from '../main/main';

/**
 * fireEmergency
 */

export function fireEmergency(RACEMANEGEMENT_HOSTNAME, token, triage, caseNo, lat, lon, organization_id, phone, name, location, setCaseNo, texts, email){

	let confirm_msg = texts.confirm_msg;
	let send_msg = texts.send_msg;
	let err_msg  = texts.err_msg;
  let result = window.confirm (confirm_msg);


  if( result ) {
    let success =  function(ret) {
      alert(send_msg);
      setCaseNo(ret.data);
    }
    let error = function(data){
      alert(err_msg);
    }
    let loc_name = location;
    if(name != null){
      loc_name = loc_name + "/ 通報者:" + name
    }
    API.createEmergency({ host:RACEMANEGEMENT_HOSTNAME, organization_id:organization_id,
                          phone_number: phone, location: loc_name,
                          lat: lat, lon: lon, triage: triage, email: email,
                          token:token, onSuccess:success, onError:error});
  }

}


export function autoFireEmergency(RACEMANEGEMENT_HOSTNAME, token, triage, caseNo, lat, lon, organization_id, phone, name, location, setCaseNo, texts, email){
	  let err_msg  = texts.err_msg;
    let success =  function(ret) {
      setCaseNo(ret.data);
    }
    let error = function(data){
      console.log(err_msg);
    }
    let loc_name = location;
    if(name != null){
      loc_name = loc_name + "/ 追跡者:" + name
    }
    console.log("追跡開始")
    API.createEmergency({ host:RACEMANEGEMENT_HOSTNAME, organization_id:organization_id,
                          phone_number: phone, location: loc_name,
                          lat: lat, lon: lon, triage: triage,
                          token:token, onSuccess:success, onError:error});

}

/**
 * sendLocation
 */
let interval = null;
export function sendLocation( RACEMANEGEMENT_HOSTNAME, token, triage, caseNo, lat, lon, organization_id, phone, name, location, track ){
		const send_interval = process.env.REACT_APP_SEND_INTERVAL;
		if(interval == null){
			interval = setInterval(() => {
				if( caseNo && track ) {
					let success =  function(ret) {
						console.log('loop:送信:', ret.data);
						return;
					}
					let error = function(data){
						console.log('loop:送信に失敗しました');
						return;
					}
					let loc_name = location;
					if(name != null){
						loc_name = loc_name + "/ 通報者:" + name
					}
					if(caseNo){
						API.updateEmergency({ host:RACEMANEGEMENT_HOSTNAME, organization_id:organization_id,
																	phone_number: phone, location: loc_name,
																	lat: lat, lon: lon, triage: triage, id: caseNo,
																	token:token, onSuccess:success, onError:error});
					}
				}
			}, send_interval);
		} else {
			console.log("send interval already running")
		}
		return interval
}

/**
 * stopLocation
 */
export function stopLocation(){
	clearInterval(interval);
	interval = null;
}

/**
 * updateStatus
 */
export function getStatus( RACEMANEGEMENT_HOSTNAME, token, caseNo, organization_id, setStatus, triage ){

  if(triage == AutoTrackTriage){
    return;
  }

  let success =  function(ret) {
    console.log('get:', ret.data);
    setStatus(ret.data);
    return;
  }
  let error = function(data){
    console.log('get:取得に失敗しました');
    console.log('get:', data);
    return;
  }
  if(caseNo){
    API.getStatus({ host:RACEMANEGEMENT_HOSTNAME, organization_id:organization_id,
                          id: caseNo,
                          token:token, onSuccess:success, onError:error});
  }
}

let status_interval = null;
export function getStatusInterval( RACEMANEGEMENT_HOSTNAME, token, caseNo, organization_id, setStatus, triage ){

    if(triage == AutoTrackTriage){
      return;
    }

		const send_interval = process.env.REACT_APP_SEND_INTERVAL;
		if(status_interval == null){
			status_interval = setInterval(() => {

        getStatus( RACEMANEGEMENT_HOSTNAME, token, caseNo, organization_id, setStatus, triage );

			}, send_interval);
		} else {
			console.log("send interval already running")
		}
		return send_interval
}

/**
 * stopLocation
 */
export function stopStatus(){
	clearInterval(status_interval);
	status_interval = null;
}
